import { requests } from "../../../services/external/APIs";
import { OvertimeReason } from "../models/overtimeReason"

const API_URL = '/jerusalem/api/v2.0.0/overtime-reasons'

export const getAllOvertimeReasons = async () : Promise<OvertimeReason[]> => 
    requests.get(`${API_URL}`);